namespace Gamification.Gamification {
    export namespace UtentiProdottiClassificheService {
        export const baseUrl = 'Gamification/UtentiProdottiClassifiche';

        export declare function Create(request: Serenity.SaveRequest<UtentiProdottiClassificheRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<UtentiProdottiClassificheRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<UtentiProdottiClassificheRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<UtentiProdottiClassificheRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/UtentiProdottiClassifiche/Create",
            Update = "Gamification/UtentiProdottiClassifiche/Update",
            Delete = "Gamification/UtentiProdottiClassifiche/Delete",
            Retrieve = "Gamification/UtentiProdottiClassifiche/Retrieve",
            List = "Gamification/UtentiProdottiClassifiche/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>UtentiProdottiClassificheService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
